import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";

export default function NotFound() {
  useSeo("Pagina non trovata", "La pagina richiesta non esiste.");
  return (
    <section className="container-x pt-44 pb-32 min-h-[70vh]" data-testid="not-found-page">
      <p className="eyebrow mb-6">Errore 404</p>
      <h1 className="font-serif font-light text-5xl sm:text-7xl tracking-[-0.02em]">Questa pagina <em className="italic">non esiste.</em></h1>
      <p className="mt-6 text-stoneish max-w-md">Forse il link è cambiato. Potete tornare alla home o sfogliare le nostre storie.</p>
      <div className="mt-10 flex flex-wrap gap-4"><Link to="/" className="btn-ink" data-testid="not-found-home">Torna alla home</Link><Link to="/portfolio" className="btn-line">Portfolio</Link></div>
    </section>
  );
}
